(ns app.front.view.group.admin.inspections.closure-categories
  (:require [app.front.entities :as entities]
            [app.front.ui.i18n :as ui-i18n]
            [app.front.ui.tag-type-editor :as ui-tag-type-editor]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.subs :as gas]
            [app.i18n.model :as i18n-model]
            [core.front.comm :as comm]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::creating-closure-category
  (fn [db _]
    (::creating-closure-category db #{})))

(rf/reg-sub ::create-closure-category-in-progress?
  :<- [::creating-closure-category]
  (fn [creating [_ config-id]] (contains? creating config-id)))

(rf/reg-event-fx ::store-new-closure-category.success
  (fn [{:keys [db]} [_ group-id on-done status response]]
    (on-done)
    {:db         (-> db
                     (update ::creating-closure-category #(disj % group-id)))
     :dispatch-n [[::entities/apply-changes status response]
                  [:notifications/add :toast :success :success :closure-category-editor/add-success]]}))

(rf/reg-event-fx ::store-new-closure-category.done
  (fn [{:keys [db]} [_ group-id status body request-id]]
    {:db       (-> db
                   (update ::creating-closure-category #(disj % group-id)))
     :dispatch (when (>= status 400)
                 (comm/error-notification-evt status body request-id))}))

(rf/reg-event-fx ::store-new-closure-category
  (fn [{:keys [db]} [_ group-id {:keys [names on-done]}]]
    {:db           (update db ::creating-closure-category #(conj (or % #{}) group-id))
     :comm/command {:command    :group/add-closure-category
                    :method     :post
                    :data       {:group-id group-id
                                 :names    names}
                    :on-success [::store-new-closure-category.success group-id on-done]
                    :on-done    [::store-new-closure-category.done group-id]}}))

(rf/reg-event-fx ::remove-closure-category
  (fn [_ [_ id]]
    {:comm/command {:command    :group/remove-closure-category
                    :method     :post
                    :data       {:category-id id}
                    :on-success [::entities/apply-changes]
                    :notify     {:success :closure-category-editor/remove-success}}}))

(rf/reg-event-fx ::rename-closure-category
  (fn [_ [_ id value language]]
    {:comm/command {:command    :group/rename-closure-category
                    :method     :post
                    :data       {:category-id id
                                 :language    language
                                 :name        value}
                    :on-success [::entities/apply-changes]
                    :notify     {:success :closure-category-editor/rename-success}}}))

(rf/reg-event-fx ::end-edit-closure-category
  (fn [_ [_ id language {:keys [name]}]]
    (let [name (get name language)]
      {:dispatch [::rename-closure-category id name language]})))

(defn- closure-category-item [entity]
  {:name (-> entity :closure-category/names i18n-model/strings-map)
   :id   (:db/id entity)
   :key  (:closure-category/key entity)})

(rf/reg-sub ::closure-categories
  (fn [[_ group-id]]
    [(rf/subscribe [::entities/entities {:entity/type                      :entity.type/closure-category
                                         :closure-category/authority-group group-id}])])
  (fn [[closure-categories] _]
    (map closure-category-item closure-categories)))

(rf/reg-sub ::closure-categories-in-use
  :<- [::gas/config-defaults]
  #(:closure-categories-in-use % #{}))

(defn- available-categories-editor [{:keys [tr group-id]}]
  (let [closure-categories (<sub [::closure-categories group-id])
        categories-in-use  (<sub [::closure-categories-in-use])
        language           (<sub [::ui-i18n/editor-language ::gas/allowed-locales])]
    [ui-tag-type-editor/editor
     {:values              closure-categories
      :edit-disabled?      #(categories-in-use (:id %))
      :name-attr           :name
      :on-create           #(>evt [::store-new-closure-category
                                   group-id
                                   %])
      :on-delete           #(>evt [::remove-closure-category
                                   (:id %)])
      :on-end-edit         (fn [{:keys [id name] :as item}]
                             (let [language (ui-i18n/get-actual-language-to-edit name language)]
                               (>evt [::end-edit-closure-category id language item])))
      :create-in-progress? (<sub [::create-closure-category-in-progress?])
      :tag-type-name       (tr [:closure-category-editor/closure-category])
      :remove-confirmation (tr [:closure-category-editor/remove-confirmation])
      :tr                  tr}]))

(defn closure-categories-editor [tr group-id]
  [:<>
   [:label.bx--label (tr [:closure-category-editor/label])]
   [available-categories-editor (util/mmap tr group-id)]])

(defn closure-categories-config-section [group-id & [section-options]]
  (let [tr (<sub [::gas/group-tr])]
    [acommon/config-section
     (tr [:group-admin/closure-categories-title])
     (tr [:group-admin/closure-categories-instruction])
     section-options
     [closure-categories-editor tr group-id]]))
